import _slicedToArray from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var D = Object.getOwnPropertySymbols;
var z = Object.prototype.hasOwnProperty,
  G = Object.prototype.propertyIsEnumerable;
var T = function T(e, t) {
  var r = {};
  for (var n in e) z.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && D) {
    var _iterator = _createForOfIteratorHelper(D(e)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var n = _step.value;
        t.indexOf(n) < 0 && G.call(e, n) && (r[n] = e[n]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return r;
};
import { useState as X, useRef as d, useCallback as Y } from "react";
import { useEffect as Z, useLayoutEffect as _ } from "react";
var J = Object.defineProperty,
  H = Object.defineProperties,
  K = Object.getOwnPropertyDescriptors,
  j = Object.getOwnPropertySymbols,
  Q = Object.prototype.hasOwnProperty,
  W = Object.prototype.propertyIsEnumerable,
  I = function I(e, t, r) {
    return t in e ? J(e, t, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: r
    }) : e[t] = r;
  },
  x = function x(e, t) {
    for (var r in t || (t = {})) Q.call(t, r) && I(e, r, t[r]);
    if (j) {
      var _iterator2 = _createForOfIteratorHelper(j(t)),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var r = _step2.value;
          W.call(t, r) && I(e, r, t[r]);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    return e;
  },
  U = function U(e, t) {
    return H(e, K(t));
  },
  S = typeof window == "undefined" ? Z : _,
  h = function h(_ref) {
    var e = _ref.isPlaying,
      t = _ref.duration,
      _ref$startAt = _ref.startAt,
      r = _ref$startAt === void 0 ? 0 : _ref$startAt,
      _ref$updateInterval = _ref.updateInterval,
      n = _ref$updateInterval === void 0 ? 0 : _ref$updateInterval,
      i = _ref.onComplete,
      y = _ref.onUpdate;
    var _X = X(r),
      _X2 = _slicedToArray(_X, 2),
      p = _X2[0],
      g = _X2[1],
      v = d(r * -1e3),
      s = d(null),
      m = d(null),
      f = d(null),
      o = d({
        elapsedTimeRef: 0,
        startAtRef: r,
        durationRef: t,
        updateIntervalRef: n
      });
    o.current = U(x({}, o.current), {
      durationRef: t,
      updateIntervalRef: n
    });
    var c = function c(a) {
        var u = a / 1e3;
        if (m.current === null) {
          m.current = u, s.current = requestAnimationFrame(c);
          return;
        }
        var _o$current = o.current,
          l = _o$current.durationRef,
          F = _o$current.elapsedTimeRef,
          C = _o$current.updateIntervalRef,
          b = _o$current.startAtRef,
          O = u - m.current,
          E = F + O;
        m.current = u, o.current = U(x({}, o.current), {
          elapsedTimeRef: E
        });
        var M = b + (C === 0 ? E : (E / C | 0) * C),
          N = b + E,
          A = typeof l == "number" && N >= l;
        g(A ? l : M), A || (s.current = requestAnimationFrame(c));
      },
      R = function R() {
        s.current && cancelAnimationFrame(s.current), f.current && clearTimeout(f.current), m.current = null;
      },
      P = Y(function (a) {
        var u = typeof a == "number" ? a : r;
        R(), o.current = U(x({}, o.current), {
          elapsedTimeRef: 0,
          startAtRef: u
        }), g(u), e && (s.current = requestAnimationFrame(c));
      }, [e, r]);
    return S(function () {
      if (y == null || y(p), t && p >= t) {
        v.current += t * 1e3;
        var _ref2 = (i == null ? void 0 : i(v.current / 1e3)) || {},
          _ref2$shouldRepeat = _ref2.shouldRepeat,
          a = _ref2$shouldRepeat === void 0 ? !1 : _ref2$shouldRepeat,
          _ref2$delay = _ref2.delay,
          u = _ref2$delay === void 0 ? 0 : _ref2$delay,
          l = _ref2.newStartAt;
        a && (f.current = setTimeout(function () {
          return P(l);
        }, u * 1e3));
      }
    }, [p, t]), S(function () {
      return e && (s.current = requestAnimationFrame(c)), R;
    }, [e]), {
      elapsedTime: p,
      reset: P
    };
  };
var q = {
    easeInCubic: function easeInCubic(e, t, r, n) {
      return e /= n, r * e * e * e + t;
    },
    easeOutCubic: function easeOutCubic(e, t, r, n) {
      return e /= n, e--, r * (e * e * e + 1) + t;
    },
    linear: function linear(e, t, r, n) {
      return r * e / n + t;
    }
  },
  V = q.easeOutCubic,
  L = function L(e) {
    return typeof e == "function" ? e : q[e];
  };
var ee = function ee(e, t) {
    if (typeof e == "number") return typeof t == "number" ? t : 2;
  },
  $ = function $(e, t) {
    return e.replace(/\B(?=(\d{3})+(?!\d))/g, t);
  },
  k = function k(e) {
    return (e.toString().split(".")[1] || "").length;
  },
  te = function te(e, t) {
    var r = k(e),
      n = k(t || 1);
    return r >= n ? r : n;
  },
  w = function w(_ref3) {
    var _ref3$isCounting = _ref3.isCounting,
      e = _ref3$isCounting === void 0 ? !1 : _ref3$isCounting,
      _ref3$start = _ref3.start,
      t = _ref3$start === void 0 ? 0 : _ref3$start,
      r = _ref3.end,
      n = _ref3.duration,
      _ref3$decimalPlaces = _ref3.decimalPlaces,
      i = _ref3$decimalPlaces === void 0 ? te(t, r) : _ref3$decimalPlaces,
      _ref3$decimalSeparato = _ref3.decimalSeparator,
      y = _ref3$decimalSeparato === void 0 ? "." : _ref3$decimalSeparato,
      _ref3$thousandsSepara = _ref3.thousandsSeparator,
      p = _ref3$thousandsSepara === void 0 ? "" : _ref3$thousandsSepara,
      g = _ref3.onComplete,
      _ref3$easing = _ref3.easing,
      v = _ref3$easing === void 0 ? V : _ref3$easing,
      s = _ref3.formatter,
      m = _ref3.updateInterval,
      f = _ref3.onUpdate;
    var o = ee(r, n),
      c = function c(a) {
        var u;
        if (o === 0 && typeof r == "number") u = r;else if (typeof r == "number" && typeof o == "number") {
          var b = L(v),
            O = a < o ? a : o;
          u = b(O, t, r - t, o);
        } else u = t + a;
        if (typeof s == "function") return s(u);
        if (i === 0) {
          var _b = Math.round(u).toString();
          return $(_b, p);
        }
        var _u$toFixed$split = u.toFixed(i).split("."),
          _u$toFixed$split2 = _slicedToArray(_u$toFixed$split, 2),
          l = _u$toFixed$split2[0],
          F = _u$toFixed$split2[1];
        return "".concat($(l, p)).concat(y).concat(F);
      },
      _h = h({
        isPlaying: e,
        duration: o,
        onComplete: g,
        updateInterval: m,
        onUpdate: typeof f == "function" ? function (a) {
          return f(c(a));
        } : void 0
      }),
      R = _h.elapsedTime,
      P = _h.reset;
    return {
      value: c(R),
      reset: P
    };
  };
var B = function B(r) {
  var n = r,
    e = n.children,
    t = T(n, ["children"]);
  var i = w(t);
  return typeof e == "function" ? e(i) : i.value;
};
B.displayName = "CountUp";
export { B as CountUp, w as useCountUp };